export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13637.4008eb8a.jpg";